module.exports = __webpack_public_path__ + "img/31.cb1af437.jpg";